<section :class="{
            simple: simple,
            expand: expand,
            'in-more': inMore
        }" class="md-search-tag template4" v-show="hasTag || (isMobileSize && !simple)">
    <div class="header" @click="toggleExpand">
        {{ $t('md-search-bar.filter', { count: tagCount })
        }}<span v-if="tagCount > 0" class="iconfont icon-arrow-down"></span>
    </div>
    <div v-if="inMore && !isMobileSize && !outSideSuggestion" class="inmore_header">
        {{ $t('md-search-bar.filterApplied', { count: tagCount }) }}
    </div>
    <div class="search-filter" :class="{ 'filter-in-more': inMore }" ref="tags">
        <label v-if="hideCount > 0" class="more-count">
            <span class="count">{{ hideCount }}</span>
            {{ simple ? '+' : $t('md-search-bar.more') }}
        </label>
        <template v-for="(item, index) in filteredTagList">
            <label v-if="index >= hideCount" :class="
                        'data-tag ' +
                        (index === 0 ? 'first' : '') +
                        (index === tagCount - 1 && hideCount ? ' last' : '')
                    " :key="index" >
                {{ item.label }}
                <span class="iconfont icon-close" @click.stop="removeTag(item)" role="button"></span>
            </label>
        </template>
        <label @click="removeAll()" class="remove-all iconfont icon-close" v-show="!collapse && !hideRemoveAll" role="button"></label>
    </div>
</section>